import React from 'react'

export default class DetalheAgencia extends React.Component {
  render () {
    if (!this.props.agencia.exibirConteudo) {
      return ''
    }

    return (
      <div className="card-body cinza-zebrado">
        <div className='row d-flex justify-content-center col-md-12 text-center mb-2'><h5>Usuários</h5></div>
        {this.props.agencia.detalhamento && this.props.agencia.detalhamento.length
          ? this.props.agencia.detalhamento.map(it => <div className='row' key={'usuario_' + it.id}>
              <div className="col-md-4">
                <p>{it.nomeComNumero}</p>
              </div>
              <div className="col-md-4">
                <p>{it.email}</p>
              </div>
              <div className="col-md-4">
                <p>{it.telefone ? it.telefone : 'Não informado'}</p>
              </div>
            </div>
          ) : <div className='row d-flex justify-content-center col-md-12 text-center'>Agência sem usuários cadastrados</div>}
      </div>
    )
  }
}
